import { render, staticRenderFns } from "./PantryList.vue?vue&type=template&id=829dca66&scoped=true&"
import script from "./PantryList.vue?vue&type=script&lang=ts&"
export * from "./PantryList.vue?vue&type=script&lang=ts&"
import style0 from "./PantryList.vue?vue&type=style&index=0&id=829dca66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "829dca66",
  null
  
)

export default component.exports